import React, { useEffect, useState } from 'react';
import StepTwo from './StepTwo';

const CreateAccount = () => {
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'conversion', { send_to: 'AW-11229548490/Y2GZCKb4k7sZEMqf1eop' });
    }
  }, []);

  return <StepTwo />;
};

export default CreateAccount;
